/**
 * Formata um número para o formato de moeda brasileira (Real - R$).
 * Ex: 6789434.88 -> R$ 6.789.434,88
 * Ex: 123.45 -> R$ 123,45
 * Ex: 5000 -> R$ 5.000,00
 * @param amount O número a ser formatado.
 * @returns Uma string formatada como moeda brasileira.
 */
export function formatCurrency(amount: number | string): string {
  if (typeof amount === 'string') {
    amount = parseFloat(amount.replace(/[^0-9.-]+/g, ''));
  }

  if (typeof amount !== 'number' || isNaN(amount)) {
    // Você pode retornar uma string vazia, 'R$ 0,00', ou lançar um erro, dependendo da sua necessidade
    console.warn("Valor inválido fornecido para formatação de moeda:", amount);
    return "0,00";
  } 

  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2, // Garante pelo menos 2 casas decimais
    maximumFractionDigits: 2, // Garante no máximo 2 casas decimais
  }).format(amount).split('R$')[1].trim();
}

export function formatCurrencyWithSymbol(amount: number | string): string {
  return `R$ ${formatCurrency(amount)}`;
}

